export const missingBirds = {
  "Abbot's Booby"					: "Abbott's Booby",
  "Pied Billed Grebe"				: "Pied-Billed Grebe",
  "Scaley-Breasted Munia"			: "Scaly-Breasted Munia",
  "Black-Crowned Night Heron"		: "Black-Crowned Night-Heron",
  "Black-Napped Oriole"				: "Black-Naped Oriole",
  "Golden Headed Cisticola"			: "Golden-Headed Cisticola",
  "Graceful Prina"					: "Graceful Prinia",
  "Kakapo"							: "Kākāpо̄",
  "Magpie Lark"						: "Magpie-Lark",
  "Many Colored Fruit Dove"			: "Many-Colored Fruit-Dove",
  "Oriental-Bay Owl"				: "Oriental Bay-Owl",
  "Red Legged Partridge"			: "Red-Legged Partridge",
  "Red Winged Black Bird"			: "Red-Winged Blackbird",
  "Sri Lanka Blue Magpie"			: "Sri Lanka Blue-Magpie",
  "Ash Throated Flycatcher"			: "Ash-Throated Flycatcher",
  "Broad Winged Hawk"				: "Broad-Winged Hawk",
  "Chestnut Collared Longspur"  	: "Chestnut-Collared Longspur",
  "Count Raggi's Bird of Paradise"	: "Count Raggi's Bird-of-Paradise",
  "Eastern Screech Owl"				: "Eastern Screech-Owl",
  "Long Tailed Tit"					: "Long-Tailed Tit",
  "Orange Footed Scrubfowl"			: "Orange-Footed Scrubfowl",
  "Plains Wanderer"					: "Plains-Wanderer",
  "Red Backed Fairywren"			: "Red-Backed Fairywren",
  "Red Eyed Vireo"					: "Red-Eyed Vireo",
  "Red Headed Woodpecker"			: "Red-Headed Woodpecker",
  "Ruby Crowned Kinglet"			: "Ruby-Crowned Kinglet",
  "Short Toed Treecreeper"			: "Short-Toed Treecreeper",
  "Wedge Tailed Eagle"				: "Wedge-Tailed Eagle",
  "White Bellied Sea Eagle"			: "White-Bellied Sea-Eagle",
  "White Breasted Woodswallow"		: "White-Breasted Woodswallow",
  "Yellow-Headed Black Bird"		: "Yellow-Headed Blackbird",
  "Australian Owlet Nightjar"		: "Australian Owlet-Nightjar",
  "Australian Shoveler"				: "Australasian Shoveler",
  "Black-Bellied Whistling Duck"	: "Black-Bellied Whistling-Duck",
  "Black Billed Magpie"				: "Black-Billed Magpie",
  "Black Shouldered Kite"			: "Black-Shouldered Kite",
  "Double Crested Cormorant"		: "Double-Crested Cormorant",
  "Elenora's Falcon"				: "Eleonora's Falcon",
  "European Bee Eater"				: "European Bee-Eater",
  "Green Pygmy Goose"				: "Green Pygmy-Goose",
  "Grey Shrike-Thrush"				: "Grey Shrikethrush",
  "Kereru"							: "Kererū",
  "Pink Eared Duck"					: "Pink-Eared Duck",
  "Pukeko"							: "Pūkeko",
  "Red Capped Robin"				: "Red-Capped Robin",
  "Rufous Banded Honeyeater"		: "Rufous-Banded Honeyeater",
  "Rufous Night Heron"				: "Rufous Night-Heron",
  "Stellar's Jay"					: "Steller's Jay",
  // "Stork-Billed Flycatcher"			: "",
  // "Tui"								: "",
  "White Faced Heron"				: "White-Faced Heron",
  "Willie Wagtail"					: "Willie-Wagtail",
  "Yellow Breasted Chat"			:  "Yellow-Breasted Chat",
}